import { cn } from "@/utils";

export const CustomShapeView = ({
  item,
  size = "large",
  onClick,
}: {
  item: {
    design: { front_proof: string; back_proof: string };
  };
  size: "small" | "large";
  onClick?: () => void;
}) => {
  const sizeClasses = size === "small" ? "h-10 w-10 lg:h-10 lg:w-10" : "";

  if (size === "small") {
    return (
      <div>
        <img
          src={item.design.front_proof}
          className={cn(
            "w-[80px] h-[50px] cursor-pointer rounded-md object-contain max-w-[unset] png-drop-shadow-sm"
          )}
          onClick={onClick}
        />
      </div>
    );
  }

  return (
    <div>
      <img
        src={item.design.front_proof}
        className={cn(
          "w-[100px] h-[70px] lg:w-[140px] lg:h-[190px] cursor-pointer rounded-md object-contain max-w-[unset] png-drop-shadow-sm lg:hidden"
        )}
        onClick={onClick}
      />
      <div className={cn("gap-2 hidden lg:flex")}>
        <img
          src={item.design.front_proof}
          className={cn(
            "w-[140px] max-h-[188px] cursor-pointer rounded-md object-contain max-w-[unset] png-drop-shadow-sm",
            sizeClasses
          )}
          onClick={onClick}
        />
        <img
          src={item.design.back_proof}
          className={cn(
            "w-[140px] max-h-[188px] cursor-pointer rounded-md object-contain max-w-[unset] png-drop-shadow-sm",
            sizeClasses
          )}
          onClick={onClick}
        />
      </div>
    </div>
  );
};
